export default "__VITE_ASSET__DvXMrYhI__"